import React, { useRef, useState, useEffect } from 'react';
import ReactPlayerYoutube from 'react-player/youtube';
import { YouTubeWrapper } from './YouTubeWrapper';
const SEEK_DETECTION_THRESHOLD_SECONDS = 2;
export const Youtube = _ref => {
  let {
    src,
    onPlayerReady,
    playing,
    muted,
    onEnd,
    disableSeekForward = false
  } = _ref;
  const playerRef = useRef(new YouTubeWrapper());
  const reactPlayerRef = useRef(null);
  const [currentTime, setCurrentTime] = useState(0);
  const [previousTime, setPreviousTime] = useState(0);
  const lastProgressTimeRef = useRef(0);

  // Update previous time using progress events instead of setInterval
  useEffect(() => {
    if (!disableSeekForward) {
      return;
    }

    // Update previous time whenever currentTime changes (from progress events)
    setPreviousTime(currentTime);
  }, [currentTime, disableSeekForward]);
  const handleProgress = state => {
    var _playerRef$current;
    const newTime = state.playedSeconds;
    if (disableSeekForward) {
      // Check if this is a seek (sudden jump in time)
      const timeDiff = Math.abs(newTime - lastProgressTimeRef.current);

      // If time jumped more than SEEK_DETECTION_THRESHOLD_SECONDS, it's likely a seek
      if (timeDiff > SEEK_DETECTION_THRESHOLD_SECONDS) {
        // If seeking forward, prevent it by seeking back to previous position
        if (newTime > previousTime) {
          console.log('YouTube: Seeking forward prevented, seeking back to:', previousTime);
          if (reactPlayerRef.current && reactPlayerRef.current.seekTo) {
            reactPlayerRef.current.seekTo(previousTime, 'seconds');
            setCurrentTime(previousTime);
            return;
          }
        }
      }
    }
    lastProgressTimeRef.current = newTime;
    setCurrentTime(newTime);

    // Call the wrapper's callOnProgress method to trigger the progress event
    (_playerRef$current = playerRef.current) == null || _playerRef$current.callOnProgress({
      played: state.played,
      playedSeconds: state.playedSeconds,
      loaded: state.loaded || 0,
      loadedSeconds: state.loadedSeconds || 0
    });
  };
  return /*#__PURE__*/React.createElement(ReactPlayerYoutube, {
    url: src,
    onReady: player => {
      var _playerRef$current2;
      reactPlayerRef.current = player;
      (_playerRef$current2 = playerRef.current) == null || _playerRef$current2.setPlayer(player);
      onPlayerReady == null || onPlayerReady(playerRef.current);
    },
    playing: playing,
    muted: muted,
    onProgress: handleProgress,
    onError: error => {
      var _playerRef$current3;
      return (_playerRef$current3 = playerRef.current) == null ? void 0 : _playerRef$current3.callOnError(error);
    },
    controls: true,
    width: "100%",
    height: "100%",
    "data-hook": "wix-vod-player-youtube",
    onEnded: onEnd
  });
};
//# sourceMappingURL=Youtube.js.map